import i18n from '@/plugins/i18n';
import { EntityPagingStoreActions } from '@/base';
import { EventHandler, Event } from '@/calendar';
import store from './store';
import EventDetails from './components/EventDetails.vue';
import { CalendarObjectTypes } from '@/modules/calendar';
import { hasPermission } from '@/json';
import { UserPermission } from '@/modules/user';

export const eventHandler: EventHandler = {
  component: {
    extends: EventDetails,
  },

  async getEvents(from, until, businessUnitId, languageId, translatorId, customerId, calendarObjectType)
  {
    if (calendarObjectType && calendarObjectType !== CalendarObjectTypes.DOCUMENT_CONTRACT || !hasPermission(UserPermission.CONTRACT_READ))
    {
      return [];
    }

    const result = await store[EntityPagingStoreActions.LIST_ALL]({
      filter: {
        completeUntilFrom: from,
        completeUntilUntil: until,
        businessUnitId,
        translatorLanguageId: languageId,
        translatorId,
        customerId,
      },
    });
    return result.content.map<Event>(c => ({
      start: c.completeUntil,
      title: `${c.translatorLanguage.isoCode}, ${c.translator ? (c.translator.lastName + ' ' + c.translator.firstName.slice(0, 1) + '.') : '-' }, ${c.customer.firstName} ${c.customer.lastName}`,
      color: c.contractComment ? 'calendar_document_translation_contract_color darken-2' : 'calendar_document_translation_contract_color',
      route: `/documenttranslation/${c.id}`,
      appointmentComment: c.contractComment,
      customerComment: c.customer.customerComment,
      translatorComment: c.translator ? c.translator.translatorComment : null,
      componentBindings: {
        contract: c,
      },
    }));
  },
};

export default eventHandler;
